var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form-group',[_c('v-row',{attrs:{"justify":"start"}},[_c('v-col',{attrs:{"cols":"6"}},[_c('skeleton',{attrs:{"width":"100","height":"30"}})],1)],1),_c('v-row',{staticClass:"pt-3"},[_c('v-col',{attrs:{"cols":"12"}},[_c('skeleton',{attrs:{"width":"100%","height":"300"}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }